import React, { useEffect, useRef, useState } from 'react';
import { Alert, Col, FormGroup, Input, Label, Row } from 'reactstrap';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { withRouter } from 'react-router';

import Loader from '../../Common/Loader';
import RoundedButton from '../../Buttons/RoundedButton/RoundedButton';
import PaypalCheckoutForm from '../../Checkout/PaypalCheckoutForm';
import StripeCheckoutForm from '../../Checkout/StripeCheckoutForm';

import { ReactComponent as UploadTrackIcon } from '../../../assets/images/upload-track.svg';

import { loadValidDiscount } from '../../../helpers/api/discounts.api';
import * as checkoutAPI from '../../../helpers/api/checkout.api';

import './UploadTrackForm.scss';

const UploadTrackForm = (props) => {
	let trackPicker = useRef(null);

	const [loading, setLoading] = useState(false);
	const [loadingDiscount, setLoadingDiscount] = useState(false);

	const [error, setError] = useState(false);
	const [success, setSuccess] = useState(false);

	const [serviceCost, setServiceCost] = useState(null);
	const [publicKey, setPublicKey] = useState(null);

	const [trackTitle, setTrackTitle] = useState('');
	const [trackFile, setTrackFile] = useState(null);

	const [amount, setAmount] = useState(0);

	const [discount, setDiscount] = useState('');
	const [discountConfirmed, setDiscountConfirmed] = useState(false);

	const [method, setMethod] = useState('');

	useEffect(() => {
		loadPaymentInfo();
	}, []);

	useEffect(() => {
		if (serviceCost > 0)
			setAmount(serviceCost);
		else setAmount(0)
	}, [serviceCost]);

	function handleOnTrackUploadClick() {
		if (trackPicker.current && trackPicker.current.click) trackPicker.current.click();
	}

	function handleOnTrackFileChange({ target: { files } }) {
		if (files && files.length > 0) {
			let track = files[0];
			if (track.type.startsWith('audio')) setTrackFile(track);
			else window.alert('Devi caricare un file audio.');
		}
	}

	function loadPaymentInfo() {
		setLoading(true);
		checkoutAPI
			.loadPaymentSetup()
			.then((result) => {
				if (result.success) {
					setServiceCost(result.serviceCost);
					setPublicKey(result.publicKey);
				}
				setLoading(false);
			})
			.catch((error) => {
				setLoading(false);
				console.log(error.message);
			});
	}

	function handleOnDiscountSubmitClick() {
		setLoadingDiscount(true);
		loadValidDiscount(discount)
			.then((result) => {
				setError('');
				setDiscount(result.discount.code)
				if (result.success && result.discount && !isNaN(result.discount.value)) {
					setDiscountConfirmed(true);
					setAmount(serviceCost * ((100 - Number(result.discount.value)) / 100))
				} else
					setError(result.message)
				setLoadingDiscount(false);
			})
			.catch(error => {
				setDiscountConfirmed(false);
				setLoadingDiscount(false);
				setError(error.message);
			})
	}

	return (
		<div className="upload-track-form" onSubmit={event => event.stopPropagation()}>
			{success ?
				<div className="h-100 w-100 d-flex flex-column align-items-center justify-content-center pr-0 pr-lg-5">
					<h3 className="my-5">Grazie!</h3>
					<p className="text-center px-5 ml-0">Attendi qualche secondo minuto e il tuo brano venga elaborato e possa essere giudicato dai nostri Talent Scout.</p>
					<RoundedButton color="primary" onClick={() => {
						setSuccess(false);
						setTrackTitle('');
						setTrackFile(null);
						setMethod('');
					}}>
						Carica un altro brano
					</RoundedButton>
					<RoundedButton className="outline" onClick={() => props.history.goBack()}>
						Torna Indietro
					</RoundedButton>
				</div>
				:
				<Row>
					<Col md="5">
						<FormGroup className="my-4" row>
							<Col>
								<Label for="title">Titolo del brano</Label>
								<Input type="text" name="title" id="title" onChange={({ target: { value } }) => setTrackTitle(value)} />
							</Col>
						</FormGroup>
						<Row>
							<Col>
								<UploadTrackIcon className="upload-track-icon" />
								<p>{trackFile ? trackFile.name : 'Nessun file caricato'}</p>
							</Col>
						</Row>

						<Row>
							<Col>
								<Input
									name="track-file"
									innerRef={trackPicker}
									type="file"
									style={{
										display: 'none'
									}}
									accept="audio/wav,audio/x-wav"
									onChange={handleOnTrackFileChange}
								/>

								<RoundedButton
									className={'px-5 mb-4 ' + (trackFile && 'outline')}
									color={!trackFile && 'primary'}
									type="button"
									disabled={!trackTitle}
									onClick={handleOnTrackUploadClick}>
									Carica brano
								</RoundedButton>
							</Col>
						</Row>
						<Row>
							<Col>
								<p>È richiesto un file in formato .wav</p>
							</Col>
						</Row>
						<Row>
							<Col>
								<h4 className='mt-2 mb-5'>Totale: € {Number(amount).toFixed(2)}</h4 >
							</Col>
						</Row>
					</Col>

					<Col className='pt-4' md={{ size: 5, offset: 1 }}>
						{loadingDiscount || loading ?
							<Loader />
							:
							<>
								{error && <Alert color="danger">{error}</Alert>}
								{trackFile && trackTitle &&
									<Row>
										<Col md="12" className=' mb-4'>

											{discount && discountConfirmed ?
												<>
													<h5>CODICE SCONTO</h5>
													<h6><strong>{discount}</strong></h6>
												</>
												: <>
													<Label for="discount">Hai un codice Sconto?</Label>
													<Input
														type="text"
														name="discount" id="discount"
														onChange={({ target: { value } }) => setDiscount(value)}
														disabled={discountConfirmed} />
													<RoundedButton
														className={'w-100 px-5'}
														color={'primary'}
														type="button"
														disabled={!discount || discountConfirmed}
														onClick={handleOnDiscountSubmitClick}>
														Inserisci Codice Sconto
													</RoundedButton>
												</>}
										</Col>
									</Row>
								}
								{trackFile && trackTitle && !method && (
									<>
										<Row>
											<Col>
												<RoundedButton
													className={'px-5 ' + ((!trackFile || !trackTitle) && 'outline')}
													color={trackFile ? 'primary' : ''}
													disabled={!trackFile || !trackTitle}
													onClick={() => setMethod('stripe')}
													type="button">
													Paga con Carta
												</RoundedButton>
											</Col>
										</Row>
										<Row>
											<Col>
												<p className="pl-0 ml-0 mb-2 text-left">oppure</p>
												<PaypalCheckoutForm
													amount={amount}
													onError={(error) => window.alert(error)}
													onSuccess={props.onSuccess}
													track={trackFile}
													title={trackTitle}
												/>
											</Col>
										</Row>
									</>
								)}
								{trackFile && trackTitle && method === 'stripe' && (
									<Row>
										<Col>
												<Elements stripe={loadStripe(publicKey)}>
													<StripeCheckoutForm
														className="d-flex flex-column justify-content-between"
														amount={amount}
														onError={(error) => window.alert(error)}
														onCancel={() => setMethod('')}
														onSuccess={() => {
															setSuccess(true);
															props.onSuccess && props.onSuccess();
														}}
														disabled={!trackFile || !trackTitle}
														track={trackFile}
														title={trackTitle}
													/>
												</Elements>
										</Col>
									</Row>
								)}
							</>}
					</Col>
				</Row>}
		</div>
	);
};

export default withRouter(UploadTrackForm);
